import { useState, useEffect } from "react";
import { AppTutorialManager1 } from "./AppTutorialManager1";
import { AppTutorialManagerMobile } from "./AppTutorialManagerMobile";
import {AppTutorialManager2} from "./AppTutorialManager2";

const MOBILE_BREAKPOINT = 900; // px — matches plan spec

/**
 * AppTutorialResponsiveSwitcher
 *
 * Renders AppTutorialManagerMobile for viewports ≤900px and
 * AppTutorialManager1 for viewports >900px.
 *
 * Uses window.matchMedia so the correct manager is chosen immediately
 * on mount (no layout-shift) and reacts live if the user resizes the
 * window across the breakpoint.
 *
 * The two managers use independent localStorage keys, so completing the
 * tutorial on one layout has no effect on the other.
 */
export const AppTutorialResponsiveSwitcher = () => {
    const [isMobile, setIsMobile] = useState<boolean>(
        () => window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches
    );

    useEffect(() => {
        const mediaQuery = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);

        const handleChange = (e: MediaQueryListEvent) => {
            setIsMobile(e.matches);
        };

        // Modern browsers
        mediaQuery.addEventListener("change", handleChange);

        return () => {
            mediaQuery.removeEventListener("change", handleChange);
        };
    }, []);

    return isMobile ? <AppTutorialManagerMobile /> : <AppTutorialManager1 />;
};

